// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root_2mrRB","container":"Container_container_Mc-o3","body":"Container_body_15GWA","spinAround":"Container_spinAround_S3rdV"};